import * as React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import 'App.css';
import RequireAuth from 'Helpers/RequireAuth';
import Login from 'Routes/Login';
import Welcome from 'Components/Welcome';
import Onboard from 'Components/Onboard/Onboard';
import ScanDevice from 'Components/ScanDevice';
import ManualDevice from 'Components/ManualDevice';
import Admin from 'Components/Admin/Admin';
import ConfirmUser from 'Components/Password/ConfirmUser';

// import ForgotPassword from 'Components/Password/ForgotPassword';
// import MainContainer from 'components/MainContainer';
// import AuthUser from 'routes/AuthUser';

function App() {
	return (
		<BrowserRouter>
			<Routes>
				{/* <Route path="/auth/:device/:deviceType/:token" element={<AuthUser />} /> */}
				<Route path="/" element={<Welcome />}></Route>
				<Route path="/login" element={<Login />}></Route>
				<Route path="/login/:deviceId" element={<Login />}></Route>
				<Route path="/scandevice" element={<RequireAuth><ScanDevice /></RequireAuth>}></Route>
				<Route path="/manual" element={<RequireAuth><ManualDevice /></RequireAuth>}></Route>
				<Route path="/admin/*" element={<RequireAuth><Admin /></RequireAuth>}></Route>
				{/* <Route path="/password/reset/:lang">
					<Route path=":token" element={<ForgotPassword />} />
					<Route path="" element={<ForgotPassword />} />
				</Route> */}
				<Route path="/:deviceId/*" element={<RequireAuth><Onboard /></RequireAuth>}></Route>
				
				<Route path="/password/confirm/:token" element={<ConfirmUser />}></Route>
			</Routes>
		</BrowserRouter>
	);
}

export default App;